import { render, staticRenderFns } from "./OrderSamplesIndex.vue?vue&type=template&id=4a62eeaa"
import script from "./OrderSamplesIndex.vue?vue&type=script&lang=js"
export * from "./OrderSamplesIndex.vue?vue&type=script&lang=js"
import style0 from "./OrderSamplesIndex.vue?vue&type=style&index=0&id=4a62eeaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports